import styled, { css } from "styled-components";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import Chip from "@mui/material/Chip";

export const GeneralSettingsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
    padding: 0;
`;

export const PageDescription = styled(Typography)`
    color: #586065;
    font-size: 0.938rem;
    line-height: 1.6;
    max-width: 640px;
    margin-bottom: 32px;
`;

export const SectionBlock = styled.section`
margin-top: 30px;
border: 1px solid #e0e0e0;
border-radius: 6px;
padding: 24px;
`;

export const SectionHeaderRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
`;

export const SectionTitle = styled(Typography)`
    font-size: 1.125rem !important;
    font-weight: 700 !important;
    color: #2b3438;
    letter-spacing: -0.01em;
    width: 100%;
    position: relative;
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const ActiveBadge = styled(Chip)`
    && {
        height: 26px;
        font-size: 0.688rem;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 0.08em;
    }
`;

export const RadioCardGrid = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;

    @media (max-width: 768px) {
        grid-template-columns: 1fr;
    }
`;

export const RadioCard = styled.label`
    position: relative;
    display: flex;
    flex-direction: column;
    padding: 24px;
    cursor: pointer;
    background-color: #f1f4f7;
    transition: all 0.25s ease;
    border: 2px solid transparent;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
    border-radius: 10px;

    &:hover {
        background-color: #eaeef2;
    }

    ${(props) =>
        props.$active &&
        css`
            border-color: #ed6c02;
            background-color: #ffffff;
            box-shadow:
                0 0 0 1px rgba(237, 108, 2, 0.15),
                0 2px 8px rgba(237, 108, 2, 0.08);
        `}

    input {
        position: absolute;
        width: 1px;
        height: 1px;
        padding: 0;
        margin: -1px;
        overflow: hidden;
        clip: rect(0, 0, 0, 0);
        white-space: nowrap;
        border: 0;
    }
`;

export const RadioCardHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 16px;
`;

export const RadioCardIcon = styled(Box)`
    width: 40px;
    height: 40px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${(props) => (props.$active ? "#fff3e0" : "#e2e9ee")};
    transition: background-color 0.25s ease;

    .MuiSvgIcon-root {
        font-size: 22px;
        color: ${(props) => (props.$active ? "#ed6c02" : "#586065")};
        transition: color 0.25s ease;
    }
`;

export const RadioIndicator = styled.div`
    width: 20px;
    height: 20px;
    border-radius: 50%;
    border: 2px solid ${(props) => (props.$active ? "#ed6c02" : "#aab3b9")};
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${(props) => (props.$active ? "#ed6c02" : "transparent")};
    transition: all 0.25s ease;
    flex-shrink: 0;
`;

export const RadioIndicatorDot = styled.div`
    width: 8px;
    height: 8px;
    background-color: #ffffff;
    border-radius: 50%;
    transform: ${(props) => (props.$active ? "scale(1)" : "scale(0)")};
    transition: transform 0.2s ease;
`;

export const RadioCardTitle = styled(Typography)`
    font-size: 1.063rem !important;
    font-weight: 700 !important;
    color: #2b3438;
    margin-bottom: 4px;
`;

export const RadioCardDescription = styled(Typography)`
    font-size: 0.85rem !important;
    color: #586065;
    line-height: 1.5;
`;

export const KeywordsCard = styled(Paper)`
    && {
        padding: 24px;
        border: 1px solid rgba(170, 179, 185, 0.1);
        border-radius: 10px;
    }
`;

export const KeywordsLabel = styled(Typography)`
    && {
        display: block;
        font-size: 0.688rem;
        font-weight: 700;
        color: #586065;
        text-transform: uppercase;
        letter-spacing: 0.08em;
        margin-bottom: 12px;
    }
`;

export const KeywordsChips = styled(Box)`
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-bottom: 28px;
`;

export const StyledKeywordChip = styled(Chip)`
    && {
        font-size: 0.8rem;
    }
`;

export const KeywordInputRow = styled(Box)`
    display: flex;
    gap: 12px;
    align-items: stretch;

    @media (max-width: 768px) {
        flex-direction: column;
    }
`;

export const StyledKeywordInput = styled(TextField)`
    flex: 1;
`;

export const PolicyCard = styled(Paper)`
    && {
        padding: 24px;
        border: 1px solid rgba(170, 179, 185, 0.15);
        box-shadow: none;
        border-radius: 10px;
    }
`;

export const PolicyRow = styled(Box)`
    display: flex;
    gap: 24px;
    align-items: flex-start;

    @media (max-width: 768px) {
        flex-direction: column;
    }
`;

export const PolicySelectWrapper = styled(FormControl)`
    && {
        width: 100%;
        max-width: 280px;

        @media (max-width: 768px) {
            max-width: 100%;
        }
    }
`;

export const PolicySelectLabel = styled(Typography)`
    && {
        display: block;
        font-size: 0.688rem;
        font-weight: 700;
        color: #586065;
        text-transform: uppercase;
        letter-spacing: 0.08em;
        margin-bottom: 12px;
    }
`;

export const PolicyHint = styled(Box)`
    flex: 1;
    border-radius: 8px;
    padding: 14px 16px;
`;

export const StickyActionBar = styled(Box)`
    margin-top: 24px;
    padding: 20px 24px;
    background-color: rgba(248, 249, 251, 0.95);
    backdrop-filter: blur(8px);
    z-index: 40;
    display: flex;
    justify-content: flex-end;
`;

export const ActionBarInner = styled(Box)`
    display: flex;
    align-items: center;
    gap: 16px;
    width: 100%;
    margin: 0 auto;
    justify-content: flex-end;

    @media (max-width: 768px) {
        flex-direction: column-reverse;
        gap: 10px;

        .MuiButton-root {
            width: 100%;
        }
    }
`;

export const LoadingWrapper = styled(Box)`
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 200px;
`;
